import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
  >
    <path d="M30.253 36.367c0-11.186 9.067-20.253 20.253-20.253 11.187 0 20.253 9.067 20.253 20.253S61.693 56.62 50.506 56.62c-11.181-.01-20.243-9.072-20.253-20.253m37.859 24.536c13.208-10 15.806-28.812 5.803-42.017C63.912 5.682 45.096 3.084 31.888 13.085 18.68 23.084 16.082 41.897 26.085 55.1a29.979 29.979 0 0 0 5.803 5.802C18.912 66.71 10 78.483 10 92.063h8.896C18.896 77.907 32.848 66.47 50 66.47s31.104 11.517 31.104 25.593H90c0-13.58-8.912-25.353-21.888-31.16" fill="currentColor" />
  </svg>
))``;
